import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { TextAlignment } from 'app/campaign/widgets.model';

@Component({
  selector: 'app-alignment',
  templateUrl: './alignment.component.html',
  styleUrl: './alignment.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AlignmentComponent {
  @Input() set setComponent(value) {
    if ((!value.component || !value.typeText) && value.requiredTypeText) return;
    if (!value.component && !value.requiredTypeText) return;
    this.component = value.component;
    this.typeText = value.typeText;
    this.direction = value.direction;
    this.initializeValues();
  }
  @Input() isCheckBox: boolean;
  @Input() customClass: string;
  @Input() isHorizontalAlignmentDisabled: boolean;
  @Input() title: string;
  @Input() brandSettingAlignment: TextAlignment;
  @Output() emitUpdatesOnComponent = new EventEmitter();
  private defaultAlignment = TextAlignment.Center;
  public TextAlignments = TextAlignment;
  public currentAlignment: TextAlignment;
  public component: any;
  public typeText: string;
  public direction: string;

  private initializeValues(): void {
    this.currentAlignment = this.component[this.typeText]?.alignment
      ? this.component[this.typeText]?.alignment
      : this.component.alignment[this.direction]
        ? this.component.alignment[this.direction]
        : this.component.alignment && !this.direction
          ? this.component.alignment
          : this.brandSettingAlignment || this.defaultAlignment;
  }

  public updateAlignment() {
    if (this.typeText) {
      this.component[this.typeText].alignment = this.currentAlignment;
    } else if (this.direction) {
      this.component.alignment[this.direction] = this.currentAlignment;
    } else {
      this.component.alignment = this.currentAlignment;
    }
    this.emitUpdatesOnComponent.emit();
  }

  get isBrandSettingsValueApplied() {
    if (this.typeText) {
      return this.component[this.typeText].alignment === null;
    } else if (this.direction) {
      return this.component.alignment[this.direction] === null;
    } else {
      this.component.alignment === null;
    }
  }

  public applyBrandSettings(): void {
    if (this.typeText) {
      this.component[this.typeText].alignment = null;
    } else if (this.direction) {
      this.component.alignment[this.direction] = null;
    } else {
      this.component.alignment = null;
    }
    this.emitUpdatesOnComponent.emit();
  }

  get isJustifyAllowed() {
    return true;
  }
}
